export default "__VITE_ASSET__CNLXTLQT__"